import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { flexRender } from '@tanstack/react-table';
import { theme } from '@xbto/design-system';
import { Row } from '../../atoms';
import { useBreakpoints } from '../../hooks';
import { SortableHeader } from '../../molecules';
export const TableHeader = ({ onSort, sortDir, sortId, table, }) => {
    /**
     * Vars
     */
    const { breakpoints } = useBreakpoints();
    /**
     * DOM
     */
    return (_jsx(_Fragment, { children: _jsx("thead", { children: table.getHeaderGroups().map(headerGroup => (_jsx("tr", { style: $.headerRow, children: headerGroup.headers.map(header => {
                    if (header.isPlaceholder) {
                        return null;
                    }
                    const { active, backgroundColor, justify, autoWidth, sortable = false, paddingHorizontal, } = (header.column.columnDef.meta || {});
                    const cellWidth = `${header.getSize()}px`;
                    const cellStyles = [
                        $.headerCell,
                        active && $.headerCellActive,
                        {
                            backgroundColor: backgroundColor && theme.color.background[backgroundColor],
                        },
                        breakpoints.LESS_THAN_M && $.headerCellSmall,
                        {
                            maxWidth: autoWidth ? 'auto' : cellWidth,
                            justifyContent: justify || 'flex-end',
                            paddingHorizontal: paddingHorizontal || undefined,
                            height: '100%',
                            width: '100%',
                        },
                    ];
                    return (_jsx("th", { style: {
                            padding: 0,
                            width: autoWidth ? 'auto' : cellWidth,
                            height: 38,
                        }, children: _jsx(Row, { style: cellStyles, children: typeof header.column.columnDef.header === 'string' ? (_jsx(SortableHeader, { id: header.id, label: header.column.columnDef.header, onSort: sortable ? onSort : undefined, sortId: sortable ? sortId : undefined, sortDir: sortable ? sortDir : undefined }, header.id)) : (flexRender(header.column.columnDef.header, header.getContext())) }) }, header.id));
                }) }, headerGroup.id))) }) }));
};
const $ = StyleSheet.create({
    headerRow: {
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
    },
    headerCell: {
        borderBottomColor: theme.color.border.primary,
        borderBottomWidth: 1,
        // @ts-expect-error This is web only
        display: 'inline-flex',
        alignItems: 'flex-end',
        paddingVertical: theme.spacing['3'],
        paddingHorizontal: theme.spacing['6'],
        color: theme.color.text.tertiary,
    },
    headerCellActive: {
        color: theme.color.text.primary,
    },
    headerCellSmall: {
        paddingHorizontal: theme.spacing['4'],
    },
});
